<template>
  <custom-dialog v-drag-dialog :title="`${model.title}（${info.contractNo}）`" :visible="visible" v-on="$listeners" width="900px" class="ship-item-dialog" :appendToBody="true">
    <div class="dialog-body">
      <!-- 表单 -->
      <el-form :model="form" :inline="true" ref="form" label-position="top" :rules="rules">
        <el-row :gutter="20">
          <!-- 产品型号原型是多选，但是后端不改 -->
          <el-col :span="12">
            <el-form-item :label="$t('crm_ship_item_dialog.fa_huo_dan_hao')">
              <el-input disabled v-model="customShipmentNum" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('crm_ship_item_dialog.ji_hua_fa_huo_ri_qi')" prop="planDeliveryDate">
              <el-col :span="24">
                <!-- <el-input v-model="form.planDeliveryDate" placeholder=""></el-input> -->
                <custom-date-picker
                  v-model="form.planDeliveryDate"
                  type="date"
                  align="right"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  default-time="00:00:00"
                  :picker-options="pickerOptionDay"
                  style="width: 100%"
                ></custom-date-picker>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="detailList">
              <span slot="label">
                {{ $t('crm_ship_item_dialog.xzbcjhfhdsb') }}
                <i style="position: absolute; right: 10px" v-if="`${form.orderClass}` !== '1'">{{ $t('crm_ship_item_dialog.zhu') }}：{{ $t('crm_ship_item_dialog.htjhrqw') }} {{ $momentLocal(info.deliveryDate, 'YYYY-MM-DD') }}</i>
              </span>
              <custom-table ref="table" height="250px" :data="tableList" tableCode="ship_device" type="checkbox" v-model="form.detailList" :slots="['bodyNum']" :filterArr="filterArr">
                <template slot="bodyNum" slot-scope="scope">
                  <p>
                    {{ scope.row.bodyNum }}
                    <span v-if="scope.row.bodyNum" @click="onClearBodyNum(scope.row, scope.$index)" class="body-num-clear el-icon-close"></span>
                  </p>
                  <el-button type="text" size="mini" @click="onDeviceDialog(scope.row, scope.$index)" v-if="!scope.row.isLock">{{ $t('crm_ship_item_dialog.xuan_ze_she_bei') }}</el-button>
                </template>
              </custom-table>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('crm_ship_item_dialog.shou_huo_ren_xin_xi')" prop="consigneeName">
              <div class="address-box" style="width: 100%">
                <div class="address-btn" v-if="!form.consigneeName" @click="changeAddress()">+</div>
                <div class="address-item" v-else>
                  <h3>
                    {{ $t('crm_ship_item_dialog.shou_hou_fang') }}{{ form.consigneeName }}（{{ $t('crm_ship_item_dialog.shou') }}）
                    {{ form.consigneePhone }}
                  </h3>
                  <p>{{ form.consigneeAddress }}</p>
                  <span class="address-modify-btn" @click="changeAddress()">{{ $t('Common.com_modify') }}</span>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
    <!-- 选择地址 -->
    <contractManagement-chooseAddress-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="addAddress"></contractManagement-chooseAddress-dialog>
    <select-device-dialog v-if="dialogVisible1" @close="dialogVisible1 = false" :model="dialogModel1" @success="changeDevice"></select-device-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import contractManagementChooseAddressDialog from '@/pages/crm/components/chooseAddressDialog.vue';
import selectDeviceDialog from '@/pages/crm/components/ship_selectDevice_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: { selectDeviceDialog, contractManagementChooseAddressDialog },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: 'add', // add、edit
          title: '',
          data: {},
        };
      },
    },
  },
  data() {
    return {
      tableList: [],
      customShipmentNum: '',
      info: {},
      form: {
        detailList: [],
        orderClass: '', // 订单类型，1-调拨 2-租赁 3-销售
        orderDeliveryId: '', // 发货计划ID
        orderId: '', // 合同或调拨单的ID
        planDeliveryDate: '', // 计划发货日期
        consigneeAddress: '', // 收货地址
        consigneeName: '', // 收货人
        consigneePhone: '', // 收货人电话
      },
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      deviceIndex: undefined,
    };
  },
  computed: {
    rules() {
      return {
        planDeliveryDate: { required: true, message: this.$t('crm_ship_item_dialog.qxzjhfhrq') },
      };
    },
    filterArr() {
      let arr = [];
      // 调拨
      if (`${this.form.orderClass}` === '1') {
        arr = ['rentalTerm', 'unitPrice', 'paymentPeriod'];
      }
      // 试用
      if (`${this.info.orderType}` === '10' || `${this.info.contractType}` === '10') {
        arr = ['unitPrice', 'paymentPeriod'];
      }
      return arr;
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      // this.form.serviceClass = this.type === 'maintain' ? this.serviceClassMap.upkeep : this.serviceClassMap.maintain;
      this.form.orderId = this.model.data.orderId;
      this.form.orderClass = this.model.data.orderClass;
      this.customShipmentNum = this.model.data.customShipmentNum;
      this.form.orderDeliveryId = this.model.data.orderDeliveryId;
      this.getTableList();
      if (this.model.type === 'edit') {
        // shipPlanInfo
        this.getOrderDetails();
      } else {
        this.getOrderInfo();
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
    },
    getOrderDetails: function () {
      this.$getJSON(apis.shipPlanInfo, {
        orderDeliveryId: this.form.orderDeliveryId,
      }).then((res) => {
        const data = res.data;
        this.info = data;
        this.$setFormatData(this.form, data);
      });
    },
    getOrderInfo: function () {
      this.$getJSON(apis.shipPlanOrderInfo, {
        orderId: this.form.orderId,
        orderClass: this.form.orderClass,
      }).then((res) => {
        const data = res.data;
        this.info = data;
        this.$setFormatData(this.form, data);
        this.form.orderClass = this.model.data.orderClass;
      });
    },
    getTableList: function () {
      this.$getJSON(apis.shipPlanDeviceNoSelect, {
        orderId: this.form.orderId,
        orderClass: this.form.orderClass,
        customShipmentNum: this.customShipmentNum,
      }).then((res) => {
        this.tableList = res.data || [];
        this.selected();
      });
    },

    // 修改地址
    changeAddress: function () {
      // service
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('crm_ship_item_dialog.xuan_ze_shou_huo_ren');
      this.dialogModel.data = {
        partnerOrgId: this.info.consigneeOrgId,
        type: 'service',
      };
    },
    // 添加地址
    addAddress: function (arg) {
      // 弹窗的类型
      const item = arg[0];
      // 售后  sdeliverAddress
      this.form.consigneeName = item.consigneeName; // 收货人
      this.form.consigneePhone = item.consigneePhone; // 收货人电话
      this.form.consigneeAddress = `${item.country}${item.province}${item.city}${item.detailAddress}`; // 详细地址
    },
    // 选择设备弹窗
    onDeviceDialog: function (row, index) {
      this.deviceIndex = index;
      this.dialogModel1.title = this.$t('crm_ship_item_dialog.xuan_ze_she_bei');
      this.dialogModel1.productCode = row.productCode;
      this.dialogModel1.productSns = row.productSns;
      this.dialogModel1.deviceBizType = row.deviceBizType;
      this.dialogVisible1 = true;
    },
    changeDevice(row) {
      // bodyNum
      var hasBodyNumOne = this.tableList.some((item) => item.bodyNum === row.bodyNum);
      if (hasBodyNumOne) {
        this.$message({
          type: 'error',
          message: this.$t('crm_ship_item_dialog.sbybxzqxzlbzwbtjdsb'),
        });
      } else {
        const item = { ...this.tableList[this.deviceIndex], deviceId: row.deviceId, bodyNum: row.bodyNum };
        this.$set(this.tableList, this.deviceIndex, item);
        this.selected();
      }
    },
    onClearBodyNum(row) {
      // 删除设备
      row.deviceId = '';
      row.bodyNum = '';
    },
    selected() {
      this.$nextTick(() => {
        this.tableList.forEach((i) => {
          if (i.selected) {
            this.$refs.table.$emit('toggleRowSelection', i, true);
          }
        });
      });
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.form.detailList.length) {
            return this.$message({
              type: 'error',
              message: this.$t('crm_ship_item_dialog.qing_xuan_ze_she_bei'),
            });
          }
          if (!this.form.consigneeName) {
            return this.$message({
              type: 'error',
              message: this.$t('crm_ship_item_dialog.qxzshr'),
            });
          }
          this.saveShip();
        }
        return null;
      });
    },
    // 保存新增编辑
    saveShip: function () {
      this.$postJSON(apis.shipPlanAdd, this.form, true).then(() => {
        if (this.model.type === 'edit') {
          this.$message({
            message: this.$t('Common.com_edit_success'),
            type: 'success',
          });
        } else {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
        }
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.ship-item-dialog {
  .el-form-item {
    width: 100%;
  }

  .el-input-number--small {
    line-height: 30px;
  }

  .mce-edit-area {
    border-top: 0;
  }

  .mce-first {
    display: none;
  }
  .body-num-clear {
    cursor: pointer;
    color: $theme-color-main;
  }
  // 地址
  .address-box {
    > h3 {
      color: #000;
      padding-bottom: 16px;
      line-height: 24px;
    }
    .address-btn {
      border: 2px dashed #00afff;
      position: relative;
      height: 80px;
      line-height: 80px;
      text-align: center;
      font-size: 40px;
      color: rgba(0, 0, 0, 0.45);
    }
    .address-item {
      border: 2px dashed #00afff;
      position: relative;
      height: 80px;
      padding: 12px 16px;
      h3 {
        line-height: 24px;
        height: 24px;
        font-size: 12px;
        color: #1e1e1e;
        font-weight: bold;
        border: none;
      }
      p {
        font-size: 12px;
        line-height: 24px;
        color: #666;
        margin-top: 8px;
        height: 24px;
      }
      .address-modify-btn {
        position: absolute;
        right: 16px;
        bottom: 10px;
        font-size: 12px;
        line-height: 24px;
        color: #f33a73;
        cursor: pointer;
      }
      .address-default {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 12px;
        color: #fff;
        padding: 0 13px;
        background: rgba(0, 0, 0, 0.19);
        border-radius: 0px 0px 0px 100px;
      }
    }
  }
}
</style>
